import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";

export async function resetPassword(id) {
  const url = URL.setId(URL.buildUrl("users"), id) + "/passwords";
  return await new API(url).put();
}
